// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RV_j","field":"styles_field__2SZvw","fieldCol":"styles_fieldCol__2jg2P","diffCol":"styles_diffCol__1S-IA","diff":"styles_diff__3H9Nr"};